<div class="row top-info-block container-alert">
  <div class="col-sm-2 xux-sidebar"></div>
  <div class="col-sm-10 xux-form-content">
    <ng-container *ngFor="let message of componentMessageData">
      <div class="alert alert-info can-restore-alert" role="alert" *ngIf="message?.type === 'info'">
        <p>{{ message?.message | translate }}</p>
      </div>

      <div class="alert alert-danger can-restore-alert" role="alert" *ngIf="message?.type === 'error'">
        <p>{{ message?.message | translate}}</p>
        <ul class="package-error-list" *ngIf="message?.errors.length > 0">
          <li *ngFor="let error of message?.errors">
            {{ error.message | translate}} {{ (error.description ? '(' + error.description + ')' : '') | translate }}<br />
            <div *ngIf="error.origin" class="error-origin-block">
              <div *ngIf="error.showOrigin">{{ error.origin }}</div>
              <div class="show-button" (click)="showMoreButtonHandler(error)">
                {{ getShowDetailsText(error) }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>
